module.exports = __webpack_public_path__ + "img/golfpractice_bodyimage03.d4f9c64e.jpg";